export { default as Img200 } from './processed/200/Killjoys_S4.jpg';
export { default as Img400 } from './processed/400/Killjoys_S4.jpg';
export { default as Imgthumb } from './processed/thumb/Killjoys_S4.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Killjoys_S4.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Killjoys_S4.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      128,
      198,
      65
    ],
    "_population": 1168,
    "_hsl": [
      0.2543859649122807,
      0.5384615384615384,
      0.5156862745098039
    ]
  },
  "LightVibrant": {
    "_rgb": [
      202,
      236,
      194
    ],
    "_population": 2682,
    "_hsl": [
      0.30158730158730157,
      0.5250000000000002,
      0.8431372549019608
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      46,
      43,
      91
    ],
    "_population": 2055,
    "_hsl": [
      0.6770833333333334,
      0.3582089552238806,
      0.2627450980392157
    ]
  },
  "Muted": {
    "_rgb": [
      111,
      129,
      100
    ],
    "_population": 2865,
    "_hsl": [
      0.27011494252873564,
      0.12663755458515283,
      0.4490196078431372
    ]
  },
  "LightMuted": {
    "_rgb": [
      170,
      194,
      151
    ],
    "_population": 442,
    "_hsl": [
      0.2596899224806202,
      0.2606060606060605,
      0.6764705882352942
    ]
  },
  "DarkMuted": {
    "_rgb": [
      48,
      52,
      94
    ],
    "_population": 1500,
    "_hsl": [
      0.6521739130434783,
      0.323943661971831,
      0.2784313725490196
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Killjoys_S4.js